/* src/app/forms/produtos/tiktok/tiktok-attribute/tiktok-attribute.component.scss */
:host {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;
}
.close {
  float: right;
  margin-top: -10px !important;
  margin-right: -20px;
  cursor: pointer;
  font-size: 100%;
}
.cardnon {
  min-height: 135px;
  max-height: 135px;
}
.warn {
  position: absolute;
  font-size: 18px;
  color: red;
  margin-left: 6px;
}
.cardred {
  min-height: 135px;
  max-height: 135px;
  border-color: red;
}
.full {
  width: 100%;
}
.multi-field {
  display: flex;
  width: 100%;
  flex-flow: row;
}
.multi-field .left {
  float: left;
  width: 65%;
}
.multi-field .right {
  float: right;
  width: 30%;
}
.data-card {
  width: 100%;
  height: 100%;
  padding: 10px;
}
.mat-mdc-card-title {
  font-size: 90%;
  text-overflow: ellipsis;
  display: block;
  white-space: nowrap;
  overflow: hidden;
}
.content {
  position: relative;
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  font-size: 120%;
  padding: 5px;
}
.content-main {
  height: 100%;
  display: flex;
  flex-direction: column;
  margin: 6px;
  overflow: auto;
}
actions-buttons {
  display: flex;
  flex-direction: column;
}
.card-content {
  padding-top: 15px;
  position: relative;
  height: 100%;
  width: 100%;
  overflow: auto;
  display: flex;
}
.select-container {
  display: flex;
  flex-direction: column;
  overflow: auto;
  height: 100%;
  width: 100%;
  position: relative;
}
/*# sourceMappingURL=tiktok-attribute.component.css.map */
